module.exports = __webpack_public_path__ + "static/some-samples-completed-cbd9a8bd92e6ecf8a0d192ffc49c9759.png";